var exports = {
  "iE": "VoiceChannelUserCount.module__wrapper___NnBxam",
  "VV": "VoiceChannelUserCount.module__users___NnBxam",
  "X5": "VoiceChannelUserCount.module__total___NnBxam",
};

module.exports = exports;
